import React from 'react';
import { MaterialDataCard } from '../../../components/UI-Elements/Grids/MaterialDataGrid';
import { IInventoryReportType } from '../../../sp-types/InventoryReportType';
import { Material } from '../../../sp-types/materialType';
import { formatToPriceInDollars } from '../../../utils/FormatValue';
import { sumInvReports } from '../../../utils/inventoryUtils';
import { getUnitObj } from '../../../utils/MassUnits/massUnitsUtils';
import TransactionsGrid from './TransactionGrid/TransactionsGrid';
import { MaterialTransaction } from './TransactionGrid/transactionGridUtils';
import { getInventoryCols } from './TransactionGrid/GridColumns';

export interface MaterialCard {
  key: string;
  name: string;
  color: string;
  quantity: number;
  tonPrice: number;
  totalPrice: number;
  fromAverage: number;
}

export interface MaterialCardsProps {
  inventoryReports: IInventoryReportType[] | undefined | null;
  colors: Record<string, string>;
  materialsMap: Record<string, Material>;
  pricesMap: Record<string, number>;
  isEditEnabled: boolean;
  isAdmin: boolean;
  onEditRow: (_id: string, _row: MaterialTransaction) => void;
  refetchInventory?: () => void;
  getCurrencyInUSD: (_currency: string) => number;
}

const MaterialsCardsBreakdown: React.FC<MaterialCardsProps> = ({
  inventoryReports,
  colors,
  materialsMap,
  pricesMap,
  isEditEnabled,
  isAdmin,
  onEditRow,
  refetchInventory,
  getCurrencyInUSD,
}) => {
  const [materialExpanded, setMaterialExpanded] = React.useState<string>('');

  return inventoryReports ? (
    <div className="flex flex-row  overflow-y-auto">
      <MaterialDataCard
        materialColorDictionary={colors}
        onExpandToggle={(materialId) => setMaterialExpanded((prev) => (prev === materialId ? '' : materialId))}
        materialsData={Object.entries(sumInvReports(inventoryReports || [], pricesMap, getCurrencyInUSD))
          .map(([materialId, totals]) => ({ ...totals, materialId, unit: materialsMap[materialId]?.unit }))
          .map(({ materialId, quantity, unit, actualPriceSum }) => ({
            materialId,
            materialNameSize: 230,
            expanded: materialExpanded === materialId,
            data: [
              {
                title: 'Quantity',
                valueAsString: quantity.toLocaleString(undefined, {
                  minimumFractionDigits: 0,
                  maximumFractionDigits: 1,
                }),
                suffix: ` ${getUnitObj(unit).shortForm}`,
                size: 120,
              },
              // {
              //   title: `Original cost (${getUnitObj(unit).shortForm})`,
              //   valueAsString: actualPriceSum ? formatToPriceInDollars(actualPriceSum / quantity, 1) : '0%',
              //   size: 120,
              // },
              {
                title: `Cost (${getUnitObj(unit).shortForm})`,
                valueAsString: actualPriceSum ? formatToPriceInDollars(actualPriceSum / quantity, 1) : '0%',
                size: 120,
              },
              {
                title: `Value (${getUnitObj(unit).shortForm})`,
                valueAsString: formatToPriceInDollars(pricesMap[materialId], 1) || 'N/A',
                size: 150,
              },
              {
                title: 'Total cost',
                valueAsString: formatToPriceInDollars(actualPriceSum),
                size: 220,
              },

              {
                title: 'Total value',
                valueAsString: formatToPriceInDollars(quantity * (pricesMap[materialId] || 1)),
                size: 220,
              },
            ],
          }))}
        materialsMap={materialsMap}
      >
        <div className="flex flex-row h-full">
          <TransactionsGrid
            colorDictionary={colors}
            {...{ materialsMap, isEditEnabled, onEditRow, inventoryReports, isAdmin }}
            refetchInventory={() => refetchInventory?.()}
            columns={getInventoryCols(
              pricesMap[materialExpanded] || 0,
              getUnitObj(materialsMap[materialExpanded]?.unit).shortForm,
              getCurrencyInUSD,
              materialsMap[materialExpanded],
            )}
            materialId={materialExpanded}
            exportType="inventory"
          />
        </div>
      </MaterialDataCard>
    </div>
  ) : (
    <div> Loading...</div>
  );
};

export default MaterialsCardsBreakdown;
